import { useEffect, useRef } from "react"

/**
 * Runs the provided effect on mount only.
 * The latest callback is stored in a ref so inline function identities do not
 * retrigger the effect on every render.
 */
const useEffectOnce = (effect: () => void | (() => void)) => {
  const effectRef = useRef<() => void | (() => void)>(effect)
  effectRef.current = effect

  useEffect(() => {
    const cleanup = effectRef.current()
    return cleanup
  }, [])
}

export { useEffectOnce }
